__turbopack_context__.v({
  "className": "libre_franklin_77ee9051-module__oLXx0q__className",
  "variable": "libre_franklin_77ee9051-module__oLXx0q__variable",
});
